import BlogArticleLayout from '@/components/feature/BlogArticleLayout';

export default function ComparacaoHoobuyPage() {
  return <BlogArticleLayout slug="comparacao-hoobuy-pandabuy" />;
}